export default __webpack_public_path__ + "static/media/1.b1221fa9.png";